import { createReducer } from 'redux-create-reducer'

const initialState = {

}


export default createReducer(initialState, {

})
